module.exports = __webpack_public_path__ + "media/src/images/zu_teaching_uni_page1-49a68b51f5ee1cdba41ae25309df0808.gif";